import { EvaluatorInviteRow } from './contracts'

export const sortRows = (
  rows: EvaluatorInviteRow[],
  nameAsc: boolean,
  nameClick: boolean
): EvaluatorInviteRow[] => {
  if (!nameClick) {
    return rows
  }

  const sorted = [...rows]
  sorted.sort((a, b) => {
    const x = (a.name ?? '').toLowerCase()
    const y = (b.name ?? '').toLowerCase()
    if (x < y) {
      return nameAsc ? 1 : -1
    }
    if (x > y) {
      return nameAsc ? -1 : 1
    }
    return 0
  })
  return sorted
}
